module.exports = __webpack_public_path__ + "media/assets/images/nosco_landing/funzionale-3d53c1bd37b3d1c6937284ab5b6dedb4.svg";